export const SvgComponent = ({ svgString }) => (
  <div dangerouslySetInnerHTML={{ __html: svgString }} />
);
